<template>
  <div class="pp-img-block w-100">
    <b-row v-if="right" class="right">
      <b-col md="6" class="d-flex align-items-center text-col">
        <div class="w-100 col-padding">
          <h2 class="title">{{ title }}</h2>
          <p>
            <slot name="description"></slot>
          </p>
          <Button
            v-if="btnText && to"
            shape="outline-transparent neutral-black"
            :to="to"
            :blank="true"
          >
            {{ btnText }}
          </Button>
        </div>
      </b-col>
      <b-col md="6" class="col-padding">
        <slot name="img"></slot>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col md="6" class="col-padding">
        <slot name="img"></slot>
      </b-col>
      <b-col md="6" class="d-flex align-items-center text-col">
        <div class="w-100 col-padding">
          <h2 class="title">{{ title }}</h2>
          <p>
            <slot name="description"></slot>
          </p>
          <Button
            v-if="btnText && to"
            shape="outline-transparent neutral-black"
            :to="to"
            :blank="true"
          >
            {{ btnText }}
          </Button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Button from 'UI/Button';

export default {
  name: 'ImgBlock',
  components: {
    Button
  },
  props: {
    title: {
      type: String,
      required: true
    },
    right: {
      type: Boolean,
      required: false,
      default: false
    },
    btnText: {
      type: String,
      required: false,
      default: ''
    },
    to: {
      type: String,
      required: false,
      default: ''
    }
  }
};
</script>

<style lang="scss">
.pp-img-block p {
  strong {
    font-weight: 500;
  }
}
</style>

<style lang="scss" scoped>
.title {
  color: #505050;
  font-size: 25px;
  font-weight: 400;
  margin-bottom: 20px;
}
p {
  color: #505050;
}
.col-padding {
  padding: 3rem;
  @include md {
    padding: 15px;
  }
}
.right {
  @include md {
    flex-wrap: wrap-reverse;
  }
}
</style>
